import { combineReducers } from 'redux';

import offersReducer from 'src/redux/reducers/offers';
import superOffersReducer from 'src/redux/reducers/super-offers';
import employersReducer from 'src/redux/reducers/employers';
import linksReducer from 'src/redux/reducers/links';
import toastReducer from 'src/redux/reducers/toast';
import tabsReducer from 'src/redux/reducers/tabs';
import impressionsReducer from 'src/redux/reducers/impressions';


const reducers = combineReducers({
  toastReducer,
  offers: offersReducer,
  superOffers: superOffersReducer,
  links: linksReducer,
  employers: employersReducer,
  tabs: tabsReducer,
  impressions: impressionsReducer
});


export default reducers;
